import React from 'react'
import { useToggle } from 'react-use'

import { IconButton } from '~/components/elements/IconButton'

import {
  DisplayToggleDialog,
  type DisplayToggleDialogProps,
} from './components/DisplayToggleDialog'

export type DisplayToggleButtonProps<
  RowId extends number | string,
  ColumnKey extends string,
> = Omit<DisplayToggleDialogProps<RowId, ColumnKey>, 'onClose'>

export const DisplayToggleButton = <
  RowId extends number | string,
  ColumnKey extends string,
>(
  props: DisplayToggleButtonProps<RowId, ColumnKey>,
) => {
  const [visibleDialog, toggleVisibleDialog] = useToggle(false)

  return (
    <>
      <IconButton fillMode="outline" icon="eye" onClick={toggleVisibleDialog} />

      {visibleDialog && (
        <DisplayToggleDialog {...props} onClose={toggleVisibleDialog} />
      )}
    </>
  )
}
